import { __assign, __extends, __rest } from "tslib";
import React, { Component } from "react";
import { PnmacSectionListView, PnmacRowItem, PnmacRowHeader, PnmacMediaQuery, PnmacMeta, PnmacText, PnmacHtmlToNative, PnmacNavigation } from "pnmac-universal-components";
import styles from '../styles/styles.js';
import moment from 'moment';
import { connect } from "react-redux";
import * as Actions from "../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import YearEndTax from '../components/YearEndTaxes.js';
import { currencyFormatter, percentFormatter, getActiveFeatures, amountNullCheck } from '../utils.js';
import { View, Platform, TouchableOpacity } from 'react-native';
import BannerView from '../v2/BannerView';
import { textStyle } from "../v2/theme/textStyle.js";
import withPnmacTitle from '../withPnmacTitle';
import { TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from "../redux/events/events.js";
var LoanInfo = function (props) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11;
  var matches = props.matches,
    layout = props.layout,
    translations = props.translations;
  var currentLoan = layout.currentLoan,
    modifications = layout.modifications;
  var titleLoanInfo = "".concat(translations === null || translations === void 0 ? void 0 : translations.LoanInformationAsOf, " ").concat(moment().format("MMM DD, YYYY"));
  var isTrialPaymentVisible = modifications === null || modifications === void 0 ? void 0 : modifications.isTrialPaymentVisible;
  var isPaymentSupplementVisible = ((_a = layout === null || layout === void 0 ? void 0 : layout.paymentSupplement) === null || _a === void 0 ? void 0 : _a.length) > 0 && ((_b = layout === null || layout === void 0 ? void 0 : layout.paymentSupplement[0]) === null || _b === void 0 ? void 0 : _b.statusId) == 2 && ((_c = layout === null || layout === void 0 ? void 0 : layout.paymentSupplement[0]) === null || _c === void 0 ? void 0 : _c.statusDesc) == "Active";
  var makeApPayment = ((_d = layout.paymentModel) === null || _d === void 0 ? void 0 : _d.canMakePayment) && !isTrialPaymentVisible;
  var nextBuydownPaymentChange = (_g = (_f = (_e = layout.buydownSubsidy) === null || _e === void 0 ? void 0 : _e.buydownSubsidySchedules) === null || _f === void 0 ? void 0 : _f.find(function (x) {
    return x;
  })) === null || _g === void 0 ? void 0 : _g.buydownSubsidySchedulePeriodicPaymentEffectiveDate;
  var yearEnd = layout === null || layout === void 0 ? void 0 : layout.yearEndData;
  var yearEnddBannerdisplayMonth = moment().format("MM");
  var DATAEXPANDABLE = [{
    title: titleLoanInfo,
    data: ((_h = layout.currentLoan) === null || _h === void 0 ? void 0 : _h.helocFlag) ? [{
      label: translations.LoanType,
      header: titleLoanInfo,
      value: parseInt(currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.lienPriorityType) === 2 ? "Closed End Second" : (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.mortgageTypeDescription) ? currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.mortgageTypeDescription : "n/a"
    }, {
      label: translations.LoanNumber,
      header: titleLoanInfo,
      value: (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanId) || "n/a"
    }, {
      label: translations.NextPaymentAmount,
      header: titleLoanInfo,
      value: makeApPayment ? currencyFormatter('en-US', 'currency', 'USD', currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.currentTotalMonthlyPaymentAmount) || "n/a" : /*#__PURE__*/React.createElement(View, {
        style: {
          cursor: "pointer"
        },
        onClick: function () {
          PnmacNavigation(__assign({
            action: {
              pathname: "/StatementsAndDocuments"
            }
          }, props));
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.formBody
      }, translations.ViewMonthlyStatement))
    }, {
      label: translations.nextPaymentDueDate,
      header: titleLoanInfo,
      value: makeApPayment ? moment((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.originalNextPaymentDueDate) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.originalNextPaymentDueDate)).format("MM/DD/YYYY") || "n/a" : /*#__PURE__*/React.createElement(View, {
        style: {
          cursor: "pointer"
        },
        onClick: function () {
          PnmacNavigation(__assign({
            action: {
              pathname: "/StatementsAndDocuments"
            }
          }, props));
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.formBody
      }, translations.ViewMonthlyStatement))
    }, {
      label: translations.AvailableCredit,
      header: titleLoanInfo,
      value: (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.creditScore) || "n/a"
    }, {
      label: translations.CreditLimit,
      header: titleLoanInfo,
      value: (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.creditScore) || "n/a"
    }, {
      label: translations.DrawExpirationDate,
      header: titleLoanInfo,
      value: moment(currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.noteDate).format("MM/DD/YYYY") || "n/a"
    }, {
      label: translations.propertyAddress,
      header: titleLoanInfo,
      value: /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.formBody
      }, currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.propertyAddressLine1)), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.formBody
      }, currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.propertyLocality, ", ", currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.propertyRegion, " ", currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.propertyPostalCode)))
    }] : [{
      label: translations.LoanType,
      header: titleLoanInfo,
      value: parseInt(currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.lienPriorityType) === 2 ? "Closed End Second" : (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.mortgageTypeDescription) ? currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.mortgageTypeDescription : "n/a"
    }, {
      label: translations.loanNumber,
      header: titleLoanInfo,
      value: (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanId) || "n/a"
    }, {
      label: translations.NextPaymentAmount,
      header: titleLoanInfo,
      value: makeApPayment ? currencyFormatter('en-US', 'currency', 'USD', currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.currentTotalMonthlyPaymentAmount) || "n/a" : /*#__PURE__*/React.createElement(TouchableOpacity, {
        style: {
          cursor: "pointer"
        },
        onPress: function () {
          PnmacNavigation(__assign({
            action: {
              pathname: "/StatementsAndDocuments"
            }
          }, props));
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.clickableLink
      }, translations.ViewMonthlyStatement))
    }, {
      label: translations.nextPaymentDueDate,
      header: titleLoanInfo,
      value: makeApPayment ? moment((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.originalNextPaymentDueDate) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.originalNextPaymentDueDate)).format("MM/DD/YYYY") || "n/a" : /*#__PURE__*/React.createElement(TouchableOpacity, {
        style: {
          cursor: "pointer"
        },
        onPress: function () {
          PnmacNavigation(__assign({
            action: {
              pathname: "/StatementsAndDocuments"
            }
          }, props));
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: __assign({}, textStyle.clickableLink)
      }, translations.ViewMonthlyStatement))
    }, {
      label: translations.PrincipalBalance,
      header: titleLoanInfo,
      value: currencyFormatter('en-US', 'currency', 'USD', currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.originalLoanAmount) || "n/a"
    }, {
      label: translations.currentPrincipalBalance,
      header: titleLoanInfo,
      value: currencyFormatter('en-US', 'currency', 'USD', currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.unpaidPrincipalBalanceAmount) || "n/a"
    }, {
      label: translations.propertyAddress,
      header: titleLoanInfo,
      value: /*#__PURE__*/React.createElement(View, {
        style: Platform.select({
          web: {
            marginRight: 20
          },
          default: {
            alignItems: 'flex-end',
            marginRight: 20
          }
        })
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.formBody
      }, currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.propertyAddressLine1), /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.formBody
      }, currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.propertyLocality, ", ", currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.propertyRegion, " ", currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.propertyPostalCode))
    }, {
      label: translations.originationDate,
      header: titleLoanInfo,
      value: moment(currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.noteDate).format("MM/DD/YYYY") || "n/a"
    }, {
      label: translations.loanMaturityDate,
      header: titleLoanInfo,
      value: moment(currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanMaturityDate).format("MM/DD/YYYY") || "n/a"
    }, {
      label: translations.originalTerm,
      header: titleLoanInfo,
      value: "".concat(currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanAmortizationTerm, " ").concat((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanAmortizationTerm) > 0 ? "".concat(translations.month, "s") : translations.month) || "n/a"
    }, {
      label: translations.remainingTerm,
      header: titleLoanInfo,
      value: "".concat(currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.currentAmortizationTerm, " ").concat((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.currentAmortizationTerm) > 1 ? "".concat(translations.month, "s") : translations.month) || "n/a"
    }, {
      label: translations.prepaymentPenalty,
      header: titleLoanInfo,
      value: (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.prepaymentPenaltyFlag) ? "Yes" : "No"
    }]
  }, !!((_j = layout === null || layout === void 0 ? void 0 : layout.buydownSubsidy) === null || _j === void 0 ? void 0 : _j.buydownSubsidyId) && {
    title: (_k = translations === null || translations === void 0 ? void 0 : translations.HudBuydownInformation) !== null && _k !== void 0 ? _k : 'HudBuydownInformation',
    data: [{
      label: (_l = translations === null || translations === void 0 ? void 0 : translations.OriginalBuydownAmount) !== null && _l !== void 0 ? _l : '',
      header: (_m = translations === null || translations === void 0 ? void 0 : translations.HudBuydownInformation) !== null && _m !== void 0 ? _m : 'HudBuydownInformation',
      value: amountNullCheck(layout.buydownSubsidy.buydownOriginalBalanceAmount)
    }, {
      label: (_o = translations === null || translations === void 0 ? void 0 : translations.BuydownDuration) !== null && _o !== void 0 ? _o : '',
      header: (_p = translations === null || translations === void 0 ? void 0 : translations.HudBuydownInformation) !== null && _p !== void 0 ? _p : 'HudBuydownInformation',
      value: layout.buydownSubsidy.buydownDurationMonths + ' ' + (translations === null || translations === void 0 ? void 0 : translations.MonthsText)
    }, {
      label: (_q = translations === null || translations === void 0 ? void 0 : translations.FirstBuydownPayment) !== null && _q !== void 0 ? _q : '',
      header: (_r = translations === null || translations === void 0 ? void 0 : translations.HudBuydownInformation) !== null && _r !== void 0 ? _r : 'HudBuydownInformation',
      value: moment(layout.buydownSubsidy.firstSubsidyPaymentDueDate).format("MM/DD/YYYY")
    }, {
      label: translations.NextBuydownPaymentChange,
      header: (_s = translations === null || translations === void 0 ? void 0 : translations.HudBuydownInformation) !== null && _s !== void 0 ? _s : 'HudBuydownInformation',
      value: nextBuydownPaymentChange ? moment(nextBuydownPaymentChange).format("MM/DD/YYYY") : "N/A"
    }, {
      label: (_t = translations === null || translations === void 0 ? void 0 : translations.LastBuydownPaymentChange) !== null && _t !== void 0 ? _t : '',
      header: (_u = translations === null || translations === void 0 ? void 0 : translations.HudBuydownInformation) !== null && _u !== void 0 ? _u : 'HudBuydownInformation',
      value: moment((_v = layout.buydownSubsidy) === null || _v === void 0 ? void 0 : _v.lastSubsidyPaymentDueDate).format("MM/DD/YYYY")
    }, {
      label: '',
      header: (_w = translations === null || translations === void 0 ? void 0 : translations.HudBuydownInformation) !== null && _w !== void 0 ? _w : 'HudBuydownInformation',
      value: /*#__PURE__*/React.createElement(View, {
        style: {
          backgroundColor: 'white',
          padding: 10
        }
      }, /*#__PURE__*/React.createElement(BannerView, null, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, props, {
        value: translations === null || translations === void 0 ? void 0 : translations.BuydownChangeNotices
      })))),
      component: true
    }]
  }, isPaymentSupplementVisible && {
    title: translations.PSTitle,
    data: [{
      label: translations.PSTotalPartialClaimNoteAmount,
      header: translations.PSTitle,
      value: currencyFormatter('en-US', 'currency', 'USD', (_x = layout === null || layout === void 0 ? void 0 : layout.paymentSupplement[0]) === null || _x === void 0 ? void 0 : _x.totalPartialClaimAmount) || "n/a"
    }, {
      label: translations.PSDuration,
      header: translations.PSTitle,
      value: "36 Months"
    }, {
      label: translations.PSFirstPayment,
      header: translations.PSTitle,
      value: moment((_y = layout === null || layout === void 0 ? void 0 : layout.paymentSupplement[0]) === null || _y === void 0 ? void 0 : _y.firstSubsidyDate).format("MM/DD/YYYY") || "n/a"
    }, {
      label: translations.PSLastPayment,
      header: translations.PSTitle,
      value: moment((_z = layout === null || layout === void 0 ? void 0 : layout.paymentSupplement[0]) === null || _z === void 0 ? void 0 : _z.lastSubsidyDate).format("MM/DD/YYYY") || "n/a"
    }, {
      label: translations.PSMonthlyReduction,
      header: translations.PSTitle,
      value: currencyFormatter('en-US', 'currency', 'USD', (_1 = (_0 = layout === null || layout === void 0 ? void 0 : layout.paymentSupplement[0]) === null || _0 === void 0 ? void 0 : _0.paymentSupplementSchedules[0]) === null || _1 === void 0 ? void 0 : _1.paymentSupplementScheduleAmount) || "n/a"
    }, {
      label: translations.PSBanner1,
      header: translations.PSTitle,
      value: "BannerInfo"
    }]
  }, !((_2 = layout.currentLoan) === null || _2 === void 0 ? void 0 : _2.helocFlag) && {
    title: translations.interestRateInformation,
    data: [{
      label: translations.currentAnnualInterestRate,
      header: translations.interestRateInformation,
      value: percentFormatter('en-US', 'percent', currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.currentInterestRate) || "n/a"
    }, {
      label: translations.nextInterestRateChange,
      header: translations.interestRateInformation,
      value: ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.armFlag) == true ? currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.nextInterestRateCalculationDate : currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.adjustmentChangeInterestRate) || "n/a"
    }, {
      label: translations.nextPaymentChange,
      header: translations.interestRateInformation,
      value: ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.armFlag) == true ? currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.nextPrincipalAndInterestPaymentCalculationDate : currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.adjustmentChangePaymentAmount) || "n/a"
    }, {
      label: translations.reasonForPaymentChange,
      header: translations.interestRateInformation,
      value: (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.armFlag) == true ? "ARM Adjustment" : "n/a"
    }]
  }, yearEnd && translations && {
    title: "".concat(translations.TaxInterestInfo, " (").concat((_3 = layout === null || layout === void 0 ? void 0 : layout.yearEndData) === null || _3 === void 0 ? void 0 : _3.taxYear, ")"),
    data: [(yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.status1098) == "0" && !(yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.is1099I30) && !(yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.is1099IntMailed) || (yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.dispositionIndicator1098) == "I" && (yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.letterStatus1098) < 30 ? {
      label: !(yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.is1098Mailed) && !(yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.is1099I30) && !(yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.is1098I30) && !(yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.is1099IntMailed) && !(yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.is1098E) && !(yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.is1098X) ? (_4 = translations.TaxBannerNotI40I30XE) === null || _4 === void 0 ? void 0 : _4.replace("{0}", yearEnddBannerdisplayMonth == "12" ? moment().format("YYYY") : moment().subtract(1, 'years').format("YYYY")).replace("{1}", yearEnddBannerdisplayMonth == "12" ? moment().add(1, 'years').format("YYYY") : moment().format("YYYY")) : translations.TaxBannerNotI40,
      header: "".concat(translations.TaxInterestInfo, " (").concat((_5 = layout === null || layout === void 0 ? void 0 : layout.yearEndData) === null || _5 === void 0 ? void 0 : _5.taxYear, ")"),
      value: "Banner"
    } : (yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.dispositionIndicator1098) != null || (yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.is1099I30) || (yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.is1099IntMailed) ? (yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.is1098X) ? {
      label: (_6 = translations === null || translations === void 0 ? void 0 : translations.TaxBannerX) === null || _6 === void 0 ? void 0 : _6.replace("{0}", yearEnddBannerdisplayMonth == "12" ? moment().format("YYYY") : moment().subtract(1, 'year').format("YYYY")),
      header: "".concat(translations.TaxInterestInfo, " (").concat((_7 = layout === null || layout === void 0 ? void 0 : layout.yearEndData) === null || _7 === void 0 ? void 0 : _7.taxYear, ")"),
      value: "Banner"
    } : (yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.is1098E) ? {
      label: translations.TaxBannerE,
      header: "".concat(translations.TaxInterestInfo, " (").concat((_8 = layout === null || layout === void 0 ? void 0 : layout.yearEndData) === null || _8 === void 0 ? void 0 : _8.taxYear, ")"),
      value: "Banner"
    } : ((yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.is1098Mailed) || (yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.is1098I30) || (yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.is1099I30) || (yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.is1099IntMailed)) && {
      label: translations.TaxBannerI30,
      header: "".concat(translations.TaxInterestInfo, " (").concat((_9 = layout === null || layout === void 0 ? void 0 : layout.yearEndData) === null || _9 === void 0 ? void 0 : _9.taxYear, ")"),
      value: /*#__PURE__*/React.createElement(YearEndTax, __assign({}, props, layout === null || layout === void 0 ? void 0 : layout.yearEndData)),
      component: true
    } : !(yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.is1098Mailed) && !(yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.is1099I30) && !(yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.is1098I30) && !(yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.is1099IntMailed) && !(yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.is1098E) && !(yearEnd === null || yearEnd === void 0 ? void 0 : yearEnd.is1098X) && {
      label: (_10 = translations.TaxBannerNotI40I30XE) === null || _10 === void 0 ? void 0 : _10.replace("{0}", yearEnddBannerdisplayMonth == "12" ? moment().format("YYYY") : moment().subtract(1, 'years').format("YYYY")).replace("{1}", yearEnddBannerdisplayMonth == "12" ? moment().add(1, 'years').format("YYYY") : moment().format("YYYY")),
      header: "".concat(translations.TaxInterestInfo, " (").concat((_11 = layout === null || layout === void 0 ? void 0 : layout.yearEndData) === null || _11 === void 0 ? void 0 : _11.taxYear, ")"),
      value: "Banner"
    }].filter(function (s) {
      return s;
    })
  }].filter(function (s) {
    return s;
  });
  var col = React.useRef();
  return /*#__PURE__*/React.createElement(View, {
    style: Platform.select({
      web: {
        marginLeft: 10,
        marginTop: 10
      },
      default: {
        marginHorizontal: 10
      }
    })
  }, /*#__PURE__*/React.createElement(PnmacSectionListView, __assign({}, props, {
    openDefaults: [titleLoanInfo],
    ref: col,
    data: DATAEXPANDABLE,
    collapsableSections: true,
    renderItem: function (_a, collapsed) {
      var _b, _c, _d, _e, _f;
      var item = _a.item,
        index = _a.index;
      if (collapsed.some(function (s) {
        return s == item.header;
      })) {
        if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanId) > 0) {
          if (/*#__PURE__*/React.isValidElement(item.value) && item.component) {
            var Cmponent = function () {
              return item.value;
            };
            return /*#__PURE__*/React.createElement(Cmponent, null);
          } else if (/*#__PURE__*/React.isValidElement(item.value)) {
            var Cmponent = function () {
              return item.value;
            };
            return /*#__PURE__*/React.createElement(View, {
              style: __assign({}, (_b = styles.selectionListView) === null || _b === void 0 ? void 0 : _b.rowItemStyles)
            }, /*#__PURE__*/React.createElement(View, {
              style: (_c = styles.selectionListView) === null || _c === void 0 ? void 0 : _c.fiftyWidth
            }, /*#__PURE__*/React.createElement(PnmacText, {
              style: textStyle.formBody
            }, item.label)), /*#__PURE__*/React.createElement(View, {
              style: (_d = styles.selectionListView) === null || _d === void 0 ? void 0 : _d.fiftyWidth
            }, /*#__PURE__*/React.createElement(Cmponent, null)));
          } else if (item.value == "Banner") {
            return /*#__PURE__*/React.createElement(BannerView, {
              style: {
                marginTop: 10
              },
              type: 'warning'
            }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, props, {
              value: item.label
            })));
          } else if (item.value == "BannerInfo") {
            return /*#__PURE__*/React.createElement(View, {
              style: {
                paddingVertical: Platform.OS == 'web' ? 8 : 0
              }
            }, /*#__PURE__*/React.createElement(BannerView, {
              style: {
                marginHorizontal: Platform.OS == 'web' ? 10 : 0
              }
            }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, props, {
              onClick: function (e) {
                props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Statments&Documents clicked from PaymentSupplement Section|Web", 0);
              },
              value: item.label,
              navigation: {
                navigate: function (params) {
                  props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Statments&Documents clicked from PaymentSupplement Section|Mobile", -1, "", false);
                  PnmacNavigation(__assign({
                    action: {
                      pathname: "/StatementsAndDocuments"
                    }
                  }, props));
                }
              }
            }))));
          }
          var notLastElement_1 = index <= ((_f = (_e = DATAEXPANDABLE.find(function (title) {
            return title.title == item.header;
          })) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.length) - 2;
          return /*#__PURE__*/React.createElement(PnmacRowItem, {
            rowContainerStyles: {
              marginTop: 0,
              marginBottom: 0
            },
            renderChildren: function () {
              var _a, _b, _c;
              return /*#__PURE__*/React.createElement(View, {
                style: __assign(__assign({}, (_a = styles.selectionListView) === null || _a === void 0 ? void 0 : _a.rowItemStyles), {
                  borderBottomLeftRadius: notLastElement_1 ? 0 : 10,
                  borderBottomRightRadius: notLastElement_1 ? 0 : 10
                })
              }, /*#__PURE__*/React.createElement(View, {
                style: (_b = styles.selectionListView) === null || _b === void 0 ? void 0 : _b.fiftyWidth
              }, /*#__PURE__*/React.createElement(PnmacText, {
                style: textStyle.formBody
              }, item.label)), /*#__PURE__*/React.createElement(View, {
                style: (_c = styles.selectionListView) === null || _c === void 0 ? void 0 : _c.fiftyWidth
              }, /*#__PURE__*/React.createElement(View, {
                style: {
                  paddingLeft: matches.small ? 10 : 0,
                  alignSelf: layout.mobile ? "flex-end" : "initial",
                  paddingRight: layout.mobile ? 20 : "initial"
                }
              }, /*#__PURE__*/React.createElement(PnmacText, {
                style: textStyle.formBody
              }, item.value))));
            }
          });
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    renderSectionHeader: function (_a) {
      var _b, _c;
      var title = _a.section.title;
      var open = ((_b = col === null || col === void 0 ? void 0 : col.current) === null || _b === void 0 ? void 0 : _b.state.collapsed.indexOf(title)) > -1;
      return /*#__PURE__*/React.createElement(PnmacRowHeader, {
        rowHeaderStyles: styles.selectionListView.rowHeaderStyles,
        rowHeaderContainerStyles: layout.mobile ? {
          marginBottom: open ? 0 : 10,
          borderBottomWidth: open ? 1 : 0,
          borderBottomColor: "#EFEFEF",
          borderBottomLeftRadius: open ? 0 : 10,
          borderBottomRightRadius: open ? 0 : 10
        } : {
          // marginBottom: open ? 0 : 10,
          // borderBottom: open ? "1px solid #e9e9e9" : "none",
          // borderBottomLeftRadius: open ? 0 : 10,
          // borderBottomRightRadius: open ? 0 : 10,
        },
        onClickExpand: function () {
          var _a;
          var c = (_a = col === null || col === void 0 ? void 0 : col.current) === null || _a === void 0 ? void 0 : _a.collapseItem(title);
        },
        item: /*#__PURE__*/React.createElement(PnmacText, {
          style: textStyle.formTitleSection
        }, title),
        isExpand: ((_c = col === null || col === void 0 ? void 0 : col.current) === null || _c === void 0 ? void 0 : _c.state.collapsed.indexOf(title)) > -1
      });
    }
  })));
};
var LoanSummary = /** @class */function (_super) {
  __extends(LoanSummary, _super);
  function LoanSummary(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      FirstName: "",
      loanId: 0,
      movr: false,
      inactive: false,
      showBanner: false,
      movrWebStatus: "Default"
    };
    return _this;
  }
  LoanSummary.prototype.componentDidMount = function () {
    if (this.props.layout.currentLoan == null) {
      this.props.fetchLoan(this.props.selectedLoanNumber);
    }
  };
  LoanSummary.prototype.render = function () {
    var _this = this;
    var _a;
    var _b = this.props,
      translations = _b.translations,
      layout = _b.layout,
      rest = __rest(_b, ["translations", "layout"]);
    var lastPaymentReceivedDate = (((_a = this.props.layout.loanArray) === null || _a === void 0 ? void 0 : _a.find(function (s) {
      return s.loanId == _this.props.layout.selectedLoanNumber;
    })) || {
      customerProperty: []
    }).lastPaymentReceivedDate;
    var message1 = (translations === null || translations === void 0 ? void 0 : translations.PaymentReceivedmsg1) + moment(lastPaymentReceivedDate).format("MM/DD/YYYY") + ". ";
    var message2 = "&#8239;" + translations.PaymentReceivedmsg2Mobile;
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      onRefresh: function () {
        _this.props.authenticate(false);
      },
      refreshing: layout.reloadingData,
      queries: {
        xSmall: "(max-width: 281px)",
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacMeta, {
        title: !matches.small ? translations.loanInformation : translations.loanInfo
      }), /*#__PURE__*/React.createElement(BannerView, {
        style: {
          marginLeft: 10,
          marginRight: Platform.OS !== 'web' ? 10 : 0,
          alignItems: matches.small || matches.medium ? undefined : 'center',
          flexDirection: matches.small || matches.medium ? "column" : "row"
        },
        type: 'success'
      }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({
        layout: layout
      }, rest, {
        size: 14,
        value: message1
      })), /*#__PURE__*/React.createElement(TouchableOpacity, {
        onPress: function () {
          return PnmacNavigation(__assign({
            action: {
              pathname: "/Loan/Activity"
            },
            layout: layout
          }, rest));
        }
      }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({
        layout: layout
      }, rest, {
        size: 14,
        value: layout.mobile ? translations.PaymentReceivedmsg2Mobile : message2
      })))), /*#__PURE__*/React.createElement(LoanInfo, __assign({}, _this.props, {
        matches: matches,
        translations: translations
      })), /*#__PURE__*/React.createElement(View, {
        style: {
          height: 30
        }
      }));
    });
  };
  return LoanSummary;
}(Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(withPnmacTitle(LoanSummary, function (_a) {
  var translations = _a.translations;
  return translations.loanInformation;
}));